import { Field, Image, ImageField, Link, LinkField, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import styles from './ImageCallToAction.module.css';

type ImageCallToActionProps = ComponentProps & {
	fields: {
		Title: Field<string>;
		Description: Field<string>;
		Image: ImageField;
		Link: LinkField;
		ButtonColour: Field<string>;
	};
};

export default withDatasourceCheck()<ImageCallToActionProps>(ImageCallToAction);

function ImageCallToAction(props: ImageCallToActionProps): JSX.Element {
	return (
		<section className={`${styles.row} maxWidth`}>
			<div className={styles.column}>
				<Text tag="h2" field={props.fields?.Title} className={styles.title} />
				<Text tag="p" field={props.fields?.Description} className={styles.description} />
				<Link field={props.fields?.Link} className={'button ' + props.fields?.ButtonColour?.value} />
			</div>

			<div className={styles.column}>
				<EditorHelp text="Image maxWidth 800px" />
				<Image media={props.fields?.Image} className={styles.image} loading="lazy" height={600} width={800} />
			</div>
		</section>
	);
}
